import ChangeAllPlacementCard from 'Components/Editor/Details/ChangeAllPlacements/ChangeAllPlacementCard';
import ChangeAllPlacementSlider from 'Components/Editor/Details/ChangeAllPlacements/ChangeAllPlacementSlider';
import { DetectionTimeSpecification } from 'Models/Project/ProjectFilterSpecifications';
import { ReactElement } from 'react';
import { padNumber } from 'Utils/conversions';

interface ChangeAllPlacementCardTimeProps {
	time: DetectionTimeSpecification | null;
	onTimeChanged: (time: DetectionTimeSpecification | null) => void;
	videoDuration: number;
}

const INITIAL_TIME_VALUE: DetectionTimeSpecification = { from: 0, to: 0 };

const ChangeAllPlacementCardTime = (props: ChangeAllPlacementCardTimeProps): ReactElement => {
	const isChecked = props.time !== null;
	const fromValue = Math.round((props.time?.from ?? 0) / 1000);
	const toValue = Math.round((props.time?.to ?? 0) / 1000);

	const getValueLabelFormat = (value: number): string => {
		const seconds = padNumber(Math.floor(value % 60), 2);
		const minutes = padNumber(Math.floor(value / 60) % 60, 2);
		const hours = padNumber(Math.floor(value / 3600), 2);
		return `${hours}:${minutes}:${seconds}`;
	};

	const startMark = {
		value: 0,
		label: getValueLabelFormat(0),
	};
	const middleMark = {
		value: Math.floor(props.videoDuration / 2),
		label: getValueLabelFormat(props.videoDuration / 2),
	};
	const endMark = {
		value: Math.floor(props.videoDuration),
		label: getValueLabelFormat(props.videoDuration),
	};
	const marks = [startMark, middleMark, endMark];

	const handlePlacementCardCheckedChanged = (checked: boolean): void => {
		if (checked) props.onTimeChanged(INITIAL_TIME_VALUE);
		else props.onTimeChanged(null);
	};

	const setValue = (from: number, to: number): void => {
		props.onTimeChanged({ from: from * 1000, to: to * 1000 });
	};

	return (
		<ChangeAllPlacementCard
			name="Select time"
			onCheckedChanged={handlePlacementCardCheckedChanged}
			isChecked={isChecked}
		>
			<ChangeAllPlacementSlider
				label="Time"
				fromValue={fromValue}
				toValue={toValue}
				min={0}
				max={props.videoDuration}
				marks={marks}
				valueLabelFormat={getValueLabelFormat}
				onValuesChanged={setValue}
				type="time"
			/>
		</ChangeAllPlacementCard>
	);
};

export default ChangeAllPlacementCardTime;
